import EmployeeListPage from './list/'
import EmployeeAddPage from './add/'
import EmployeeViewPage from './view/'

export default {
  EmployeeListPage,
  EmployeeAddPage,
  EmployeeViewPage
}
